import { InitOptions } from 'i18next';
import { localeArray } from './locales';
import { getEnvVar } from '@vimond/utils/env';

export const fallbackLng = getEnvVar('NEXT_PUBLIC_DEFAULT_LANGUAGE') ?? 'en';
export const languages = localeArray;
export const defaultNS = 'translation';
export const cookieName = 'Next-Locale';

export function getOptions(lng = fallbackLng, ns = [defaultNS]): InitOptions {
  return {
    supportedLngs: languages,
    lng,
    fallbackLng,
    fallbackNS: defaultNS,
    ns,
    defaultNS,
  };
}
